var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0714 1.92857H14.1429V0.642869C14.1429 0.287816 13.855 0 13.5 0C13.1449 0 12.8571 0.287816 12.8571 0.642869V1.92857H5.14284V0.642869C5.14284 0.287816 4.85502 0 4.50001 0C4.14499 0 3.85714 0.287816 3.85714 0.642869V1.92857H1.92857C0.863449 1.92857 0 2.79202 0 3.85714V16.0714C0 17.1366 0.863449 18 1.92857 18H16.0714C17.1366 18 18 17.1366 18 16.0714V3.85714C18 2.79202 17.1366 1.92857 16.0714 1.92857V1.92857ZM16.7142 16.0714C16.7142 16.4264 16.4264 16.7143 16.0713 16.7143H1.92851C1.57346 16.7143 1.28564 16.4264 1.28564 16.0714V7.71423H16.7142V16.0714V16.0714ZM16.7142 6.42854H1.28564V3.8571C1.28564 3.50205 1.57346 3.21423 1.92851 3.21423H3.85708V4.49993C3.85708 4.85499 4.1449 5.1428 4.49995 5.1428C4.85501 5.1428 5.14282 4.85499 5.14282 4.49993V3.21423H12.8571V4.49993C12.8571 4.85499 13.1449 5.1428 13.5 5.1428C13.855 5.1428 14.1428 4.85499 14.1428 4.49993V3.21423H16.0714C16.4265 3.21423 16.7143 3.50205 16.7143 3.8571V6.42854H16.7142Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14341 9H3.85771C3.50266 9 3.21484 9.28782 3.21484 9.64287C3.21484 9.99792 3.50266 10.2857 3.85771 10.2857H5.14341C5.49847 10.2857 5.78628 9.99792 5.78628 9.64287C5.78628 9.28782 5.49847 9 5.14341 9V9Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64341 9H8.35771C8.00266 9 7.71484 9.28782 7.71484 9.64287C7.71484 9.99792 8.00266 10.2857 8.35771 10.2857H9.64341C9.99847 10.2857 10.2863 9.99792 10.2863 9.64287C10.2863 9.28782 9.99847 9 9.64341 9V9Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1434 9H12.8577C12.5027 9 12.2148 9.28782 12.2148 9.64287C12.2148 9.99792 12.5027 10.2857 12.8577 10.2857H14.1434C14.4985 10.2857 14.7863 9.99792 14.7863 9.64287C14.7862 9.28782 14.4984 9 14.1434 9V9Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14341 11.5714H3.85771C3.50266 11.5714 3.21484 11.8592 3.21484 12.2142C3.21484 12.5693 3.50266 12.8571 3.85771 12.8571H5.14341C5.49847 12.8571 5.78628 12.5693 5.78628 12.2142C5.78628 11.8592 5.49847 11.5714 5.14341 11.5714V11.5714Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64341 11.5714H8.35771C8.00266 11.5714 7.71484 11.8592 7.71484 12.2142C7.71484 12.5693 8.00266 12.8571 8.35771 12.8571H9.64341C9.99847 12.8571 10.2863 12.5693 10.2863 12.2142C10.2863 11.8592 9.99847 11.5714 9.64341 11.5714V11.5714Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1434 11.5714H12.8577C12.5027 11.5714 12.2148 11.8592 12.2148 12.2142C12.2148 12.5693 12.5027 12.8571 12.8577 12.8571H14.1434C14.4985 12.8571 14.7863 12.5693 14.7863 12.2142C14.7862 11.8592 14.4984 11.5714 14.1434 11.5714V11.5714Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14341 14.1429H3.85771C3.50266 14.1429 3.21484 14.4308 3.21484 14.7858C3.21484 15.1409 3.50266 15.4286 3.85771 15.4286H5.14341C5.49847 15.4286 5.78628 15.1408 5.78628 14.7858C5.78628 14.4307 5.49847 14.1429 5.14341 14.1429V14.1429Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64341 14.1429H8.35771C8.00266 14.1429 7.71484 14.4308 7.71484 14.7858C7.71484 15.1409 8.00266 15.4287 8.35771 15.4287H9.64341C9.99847 15.4287 10.2863 15.1409 10.2863 14.7858C10.2863 14.4308 9.99847 14.1429 9.64341 14.1429V14.1429Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1434 14.1429H12.8577C12.5027 14.1429 12.2148 14.4308 12.2148 14.7858C12.2148 15.1409 12.5027 15.4287 12.8577 15.4287H14.1434C14.4985 15.4287 14.7863 15.1409 14.7863 14.7858C14.7863 14.4308 14.4984 14.1429 14.1434 14.1429V14.1429Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.0410f64e0c579782b2019b411d2d706a.svg";
export { ForwardRef as ReactComponent };